import React, {useEffect, useState} from "react";
import './ServiceAgreement.css'
import Header from "../../../components/header/Header";
import Indicator from "../../common/components/Indicator";
import {Button, Form, message, Input, Checkbox} from "antd";
import ModalContent from "../../../constant/ModalContent";
import {useNavigate} from "react-router-dom";


const {TextArea} = Input;
export default function ServiceAgreement() {


    const [isLoading, setIsLoading] = useState(false);

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [checked,setChecked] = useState(false)

    const sessionId = localStorage.getItem('sessionId')

    useEffect(() => {
        form.setFieldValue('isChecked' , false);
    }, []);


    useEffect(()=>{
        if (!sessionId){
            // Redirect to NotFoundPage if any data is null
            navigate('/not-found-page');
        }
    },[])



    const handleSubmit = async (values) => {
        setIsLoading(true);

        try {

            const isChecked = form.getFieldValue('isChecked');

            if (isChecked){
                setIsLoading(false);
                navigate("/review-plan-details");
            }

        } catch (error) {
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION, 1);
            throw new Error(error);
        }
    }

    const handelCheckboxChange = async ()=>{
        const isChecked = form.getFieldValue('isChecked');
        setChecked(isChecked);
    }


    return (
        <div>
            <div style={{backgroundColor: "#E6E6E6", width: "100%"}}>
                <Header/>
            </div>

            {isLoading && <Indicator/>}


                (
                    <Form
                        form={form}
                        className="form"
                        name="form"
                        onFinish={handleSubmit}
                    >
                        <h1 className="para-title">
                            Service agreement
                        </h1>

                        <Form.Item>
                            <Input.TextArea readOnly rows={8} defaultValue={`This Service Agreement (the \"Agreement\") is entered into by and between [Your Company Name], a [Legal Structure of Your Company] (\"Service Provider\"), and [Client's Name], a [Client's Legal Structure] (\"Client\"). Collectively, the parties shall be referred to as the \"Parties.\" 1. Services to be Provided Service Provider agrees to provide the following services to the Client (the \"Services\"): [Provide a detailed description of the services to be provided, including any specific deliverables, milestones, or timelines.] 2. Compensation In consideration for the Services provided by the Service Provider, the Client agrees to pay the Service Provider the following fees: [Specify the payment terms, including the amount of fees, due dates, and any other relevant payment details.] 3. Term and Termination This Agreement shall commence on [Start Date] and shall continue until terminated by either Party with [number] days written notice. Either Party may terminate this Agreement immediately for cause upon written notice to the other Party if the other Party breaches any material term or condition of this Agreement. 4. Confidentiality Both Parties agree to keep confidential all information exchanged during the term of this Agreement, including but not limited to proprietary information, trade secrets, and business strategies. 5. Intellectual Property All intellectual property developed or created by the Service Provider in the course of providing the Services shall remain the property of the Service Provider unless otherwise agreed upon in writing. 6. Governing Law This Agreement shall be governed by and construed in accordance with the laws of [Your Jurisdiction]. 7. Miscellaneous Any amendments to this Agreement must be made in writing and signed by both Parties. This Agreement constitutes the entire understanding between the Parties and supersedes all prior agreements or understandings, whether oral or written. IN WITNESS WHEREOF, the Parties hereto have executed this Service Agreement as of the Effective Date."`}
                            />
                        </Form.Item>

                        <Form.Item
                            name="isChecked"
                            valuePropName="checked"
                        >
                            <Checkbox onChange={handelCheckboxChange}>
                                <div style={{textAlign: "left"}}>
                                    By clicking here, you accept these Service Terms.
                                </div>
                            </Checkbox>
                        </Form.Item>



                        <Form.Item>
                            <Button
                                className="mainButton agreeButton"
                                type="primary"
                                htmlType="submit"
                                shape={"round"}
                                style={{backgroundColor: "#f13434",marginRight: 10}}
                                disabled={!checked}
                            >
                                Continue
                            </Button>
                            <Button
                                className="mainButton rejectButton"
                                type="primary"
                                htmlType="submit"
                                shape={"round"}
                                style={{color: "#f13434",border: '1px solid #f13434',backgroundColor: 'white'}}
                                disabled={isLoading}
                                onClick={() => navigate('/set-up')}
                            >
                                Go back
                            </Button>
                        </Form.Item>
                    </Form>
                )

        </div>
    );
}